import React from "react";

// Shown when the user has no profile picture or it fails to load
const DEFAULT_AVATAR = "/assets/images/user/avatar-1.jpg";

interface IProps {
  imageUrl?: string;
  size: number;
  className?: string;
}

const UserAvatar = ({ imageUrl, size, className }: IProps) => (
  <img
    src={imageUrl || DEFAULT_AVATAR}
    alt="user-image"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: "cover", borderRadius: "50%" }}
    onError={(e) => {
      if (e.currentTarget.src.endsWith(DEFAULT_AVATAR)) return;
      e.currentTarget.src = DEFAULT_AVATAR;
    }}
  />
);

export default UserAvatar;
